import request from '../../shared/request'

export function getLeadsList(param) {
  return request(`/lead/${param.status}/`)
}

export function getLeadDetails(lead_id) {
  return request(`/lead/${lead_id}/details`)
}

export function updateLeadDetail(payload) {
  return request(`/lead/${payload.lead_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createLead(payload) {
  return request(`/lead/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLead(payload) {
  return request(`/lead/${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function markAsDeadLead(payload) {
  return request(`/lead/${payload.leadId}/dead`, {
    method: 'PUT',
    body: { markAsAlive: payload.markAsAlive },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function cloneLead(payload) {
  return request(`/lead/${payload.leadId}/clone`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getLeadContracts(param) {
  return request(`/lead/${param.leadId}/contracts`)
}

export function createJobFromLead(payload) {
  return request(`/lead/${payload.lead_id}/job`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead.js